module.exports = __webpack_public_path__ + "static/media/1img.62bc1c53.png";